import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  @Input() message: string = 'Are you sure you want to proceed?';
  @Input() title: string = 'Confirm Action';
  @Input() confirmText: string = 'Yes';
  @Input() cancelText: string = 'Cancel';
  @Input() confirmButtonClass: string = 'btn-primary';
  @Input() cancelButtonClass: string = 'btn-secondary';

  constructor(public activeModal: NgbActiveModal, private cd: ChangeDetectorRef) {}

  confirm(): void {
    this.activeModal.close(true);
  }

  cancel(): void {
    this.activeModal.close(false);
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
